import { createMuiTheme } from '@material-ui/core/styles'
import { heading } from '../../utils/utils'

const headingFont = 'Karla'
const bodyFont = 'Karla'

const white = '#fff'
const black = '#000'
const primaryMain = '#0F5780'
const primaryLight = '#cce8f7'
const secondaryMain = '#0F5780' // Changed from green #B4D2C1 to dark blue
const greyLight = '#F7F7F9'

// const imp = '!important'

// const f11 = `11px`
const f12 = `12px`
const f13 = `13px`
const f14 = `14px`
const f15 = `15px`
const f16 = `16px`
const f18 = `18px`

// const f20 = `20px`
// const f22 = `22px`
const f24 = `24px`
// const f30 = `30px`
const f32 = `32px`

const body = {
  fontSize: f14,
  lineHeight: 1.6,
}
const body2 = {
  fontSize: f13,
  lineHeight: 1.67,
}

const breakpoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
}

const theme = createMuiTheme({
  themeFont: {
    //WARNING FONT NAME WITH SPACE SHOULD HAVE A +. NEXT JS TRIGGER BAD URL FOR GOOGLE FONT
    main: 'Karla',
    secondary: 'Karla',
  },
  breakpoints: {
    values: breakpoints,
  },
  typography: {
    fontFamily: `${bodyFont}, sans-serif`,
    h1: {
      lineHeight: 1.15,
      ...heading(f32, f32, 400, 400, headingFont, headingFont, false),
    },
    h2: {
      lineHeight: 1.15,
      ...heading(f24, f24, 400, 400, headingFont, headingFont, false),
    },
    h3: {
      lineHeight: 1.4,
      ...heading(f18, f18, 400, 400, headingFont, headingFont, false),
    },
    h4: {
      lineHeight: 1.55,
      ...heading(f16, f16, 700, 700, headingFont, bodyFont, false),
    },
    h5: {
      lineHeight: 1.25,
      ...heading(f14, f14, 700, 700, headingFont, bodyFont, false),
    },
    h6: {
      lineHeight: 1.25,
      ...heading(f12, f12, 700, 700, headingFont, bodyFont, false),
    },
    body1: {
      ...body,
    },
    body2: {
      ...body2,
    },
    caption: {
      fontSize: f12,
      lineHeight: 1.17,
      fontWeight: 400,
    },
    button: {
      fontSize: f15,
      lineHeight: 1.67,
      textTransform: 'inherit',
    },
  },
  palette: {
    common: {
      black: primaryMain,
      white: white,
    },
    background: {
      default: white,
      paper: white,
    },
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    success: {
      main: '#47E169',
    },
    error: {
      main: '#FA3232',
    },
    warning: {
      main: '#FF8333',
    },
    divider: greyLight,
    primaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    secondaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    ternary: {
      main: '#0082C3',
      light: '#F1FAFF',
    },
    accent: {
      main: '#FFEA28',
    },
  },
  sizes: {
    headerHeight: 60,
    headerHeightTransparent: 90,
    logoWidth: 110,
    logoHeight: 60,
    footerBG: 168,
    basketWidth: 340,
    basketWidthLG: 440,
  },
  extraColors: {
    grey: '#D5D2D9',
    greyLight: '#F5F3F8',
    greyMedium: '#C0BCC6',
    greyText: '#6F677B',
  },
  shadows: [
    'none',
    '0px 0px 15px rgba(46, 46, 46, 0.1)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        // Banner styling - reduced line spacing (35px → 25px)
        '.title > h1': {
          margin: 24,
        },
        '.banner': {
          padding: '0 !important',
          color: `${primaryMain} !important`,
          backgroundColor: `${primaryLight} !important`,
          '& h1, & h2, & .banner__title': {
            lineHeight: '1.2 !important',
            marginBottom: '25px !important',
          },
          '& .banner__subtitle': {
            marginTop: '0 !important',
          },
        },
        // Header styling - increased text size
        '.header': {
          '&__cta': {
            color: `${primaryMain} !important`,
          },
          '& a, & span': {
            fontSize: `${f16} !important`,
          },
        },
        // Product card text colors - black text, blue titles
        '.discover-product': {
          '&__title': {
            color: `${primaryMain} !important`,
          },
          '&__price': {
            color: `${black} !important`,
          },
        },
        // Sold out styling - light blue background, dark blue text
        '.sold-out, .out-of-stock, [class*="soldOut"], [class*="outOfStock"]': {
          backgroundColor: `${primaryLight} !important`,
          color: `${primaryMain} !important`,
          borderColor: `${primaryMain} !important`,
        },
        '.victim-success, [class*="victimSuccess"], [class*="victime"]': {
          backgroundColor: `${primaryLight} !important`,
          color: `${primaryMain} !important`,
        },
        // Social icons - reduced size and centered
        '.social-icons, [class*="socialIcons"], [class*="social-network"]': {
          '& svg, & img': {
            width: '20px !important',
            height: '20px !important',
          },
          '& a': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
          },
        },
        // Price display styling
        '.product-price, [class*="productPrice"]': {
          '&__old, &__crossed, [class*="oldPrice"], [class*="crossed"]': {
            textDecoration: 'line-through',
            color: `${black} !important`,
          },
          '&__new, &__current, [class*="newPrice"], [class*="current"]': {
            color: `${primaryMain} !important`,
          },
        },
        '.hero': {
          '&__title, &__toptitle': {
            color: `${primaryMain} !important`,
          },
          '&__title': {
            '&__container': {
              flexDirection: 'column-reverse !important',
              textAlign: 'center !important',
              [`@media (max-width: ${breakpoints.sm}px)`]: {
                paddingTop: '48px !important',
              },
            },
          },
        },
        '.productCard': {
          '&__soldout': {
            color: `${primaryMain} !important`,
            backgroundColor: `${primaryLight} !important`,
          },
          '&__add': {
            marginLeft: 'auto',
            bottom: '-21px',
          },
          '&__cta': {
            width: '32px !important',
            height: '32px !important',
          },
          '&__price': {
            '&--original': {
              '& .price__amount': {
                textDecoration: 'line-through',
              },
            },
            '&--ttc': {
              color: `${black} !important`,
              fontWeight: '500 !important',
            },
          },
        },
        '.product': {
          '&__head': {
            justifyContent: 'space-between',
            '& .MuiGrid-container': {
              padding: 8,
            },
          },
        },
        '.takeBack__header__text': {
          color: `${black} !important`,
        },
        '.search__button__icon__only': {
          color: `${primaryMain} !important`,
        },
        'a.menu__link': {
          fontSize: `${f14} !important`,
          fontWeight: '700 !important',
        },
        // General text styling - black text, blue for main titles
        body: {
          color: black,
        },
        '.hiw': {
          '&__icon': {
            '& .hiw__img': {
              height: '128px',
            },
          },
        },
        '.shop-menu--products': {
          display: 'flex !important',
        },
        '.shop-filters': {
          fontSize: '16px !important',
          fontWeight: 'bold !important',
          backgroundColor: '#CCE8F7 !important',
        },
        '.shop-menu__sort-input': {
          fontSize: '16px !important',
          fontWeight: 'bold !important',
          backgroundColor: '#CCE8F7 !important',
        },
      },
    },
    MuiButton: {
      root: {
        padding: '12px 45px',
        borderRadius: 10,
        color: primaryMain,
      },
      sizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
      sizeLarge: {
        padding: '12px 45px',
      },
      contained: {
        boxShadow: 'none',
        backgroundColor: primaryMain,
        color: `${white} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          boxShadow: 'none',
          backgroundColor: primaryMain,
        },
        '& .MuiButton-label': {
          color: `${white} !important`,
        },
      },
      containedSecondary: {
        backgroundColor: primaryMain,
        color: `${white} !important`,
        '&:hover, &:focus, &:active': {
          backgroundColor: '#0a4566', // Darker blue on hover
        },
      },
      outlined: {
        padding: '12px 45px',
        borderColor: primaryMain,
        color: primaryMain,
        '&:hover': {
          borderColor: primaryMain,
          backgroundColor: primaryLight,
        },
      },
      outlinedSizeLarge: {
        padding: '12px 45px',
      },
      outlinedSizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
    },
    MuiPaper: {
      root: {
        boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiSelect: {
      root: {
        color: primaryMain,
      },
      selectMenu: {
        '&:focus': {
          background: white,
        },
      },
    },
    MuiChip: {
      root: {
        borderRadius: 0,
        fontSize: 15,
        fontWeight: 700,
        color: black,
        backgroundColor: 'transparent',
        height: 25,
        padding: 0,
      },
      label: {
        padding: 0,
      },
      sizeSmall: {
        height: 22,
        fontSize: 12,
        fontWeight: 400,
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      colorPrimary: {
        color: primaryMain,
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        color: secondaryMain,
        backgroundColor: 'transparent',
      },
    },
  },
})

export default theme
